import { Component, EventEmitter, inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { UnpaidPaymentsIsDummyService } from '../../unpaid-payments-is-dummy.service';
import { ToggleComponent } from '../../../../../shared/components/ui/toggle/toggle.component';

@Component({
  selector: 'app-unpaid-payments-is-dummy-toggle',
  standalone: true,
  imports: [ToggleComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <app-toggle
      [checked]="isDummyService.isDummy()"
      label="Dummy Data"
      labelPosition="before"
      size="sm"
      className="shrink-0 whitespace-nowrap"
      (toggleChange)="onToggle($event)"
    ></app-toggle>
  `,
})
export class UnpaidPaymentsIsDummyToggleComponent {
  readonly isDummyService = inject(UnpaidPaymentsIsDummyService);

  @Output() dummyChange = new EventEmitter<boolean>();

  onToggle(checked: boolean): void {
    this.dummyChange.emit(checked);
  }
}
